import React, { FC, useContext } from 'react';
import { SessionContext } from '../SessionGuard';
import { useSettings } from '../hooks';

export type ComponentLoaderProps<P> = {
  /**
   * Component to render
   */
  component: FC<P>;
  /**
   * Component Settings
   */
  clientSettings: P;
  /**
   * Component skeleton loader
   */
  loader?: FC;
};

const DefaultLoader = () => <p>Session loading...</p>;

const ComponentLoader = <P,>({
  component,
  loader,
  clientSettings,
}: ComponentLoaderProps<P>) => {
  const { sessionInitialized } = useContext(SessionContext);
  const settings = useSettings<P>(clientSettings);
  let componentToRender;

  if (sessionInitialized && settings) {
    return React.createElement(component, { ...(settings as P) });
  } else if (loader) {
    componentToRender = loader;
  } else {
    componentToRender = DefaultLoader;
  }

  return React.createElement(componentToRender);
};

export default ComponentLoader;
